import {
  ComputerDesktopIcon,
  DevicePhoneMobileIcon
} from '@heroicons/react/24/outline'

import { GAMES, JOB } from '../content'
import { anim, stagger, travel } from '../motion'
import { Avatar, Box, Phone, Shape } from '../primitives'

export const PHONE = { x: 610, y: 50 }

export { GAMES }

// Schritte: 0 Einladung kommt an · 1 Übersicht im Assessment
export default function SceneInvitation() {
  return (
    <>
      <Box
        x={40}
        y={50}
        w={380}
        h={96}
        className='sty-card sty-pad sty-row'
        style={anim({ at: [0.01, 0.08] })}
      >
        <Avatar initials='L' color='pink' size={52} />
        <div>
          <div className='sty-h4'>Lena K.</div>
          <div className='sty-muted'>bewirbt sich als {JOB}</div>
        </div>
      </Box>

      <Box
        x={40}
        y={176}
        w={380}
        h={220}
        className='sty-card'
        style={anim({ at: [0.04, 0.12], x: -30, y: 0 })}
      >
        <div className='sty-mail__head'>
          <div className='sty-muted'>Von Mara, Recruiting</div>
          <div className='sty-strong'>Dein nächster Schritt</div>
        </div>
        <div className='sty-pad'>
          <div className='sty-ph' style={{ width: '92%' }} />
          <div className='sty-ph' style={{ width: '78%' }} />
          <div className='sty-ph' style={{ width: '64%' }} />
          <div className='sty-btn sty-mt-3'>Assessment starten</div>
        </div>
      </Box>

      {/* Der Link wandert vom Button aufs Smartphone */}
      <div
        className='sty-abs'
        style={{
          left: 0,
          top: 0,
          ...travel({ at: [0.12, 0.2], from: [120, 340], to: [730, 110] })
        }}
      >
        <Shape kind='dot' color='blue' size={18} />
      </div>

      <Box
        x={40}
        y={428}
        w={380}
        h={60}
        className='sty-row'
        style={anim({ at: [0.6, 0.7] })}
      >
        <span className='sty-chip'>
          <DevicePhoneMobileIcon className='sty-icon' /> Smartphone
        </span>
        <span className='sty-muted'>oder</span>
        <span className='sty-chip'>
          <ComputerDesktopIcon className='sty-icon' /> Browser
        </span>
      </Box>

      <Phone x={PHONE.x} y={PHONE.y} style={anim({ at: [0.02, 0.1], y: 40 })}>
        <div
          className='sty-abs sty-notification'
          style={anim({ at: [0.18, 0.24], out: [0.5, 0.55], y: -30 })}
        >
          <Shape kind='sq' color='blue' size={22} />
          <div>
            <div className='sty-strong sty-small'>Neue Einladung</div>
            <div className='sty-muted sty-small'>
              Dein Game-based Assessment wartet
            </div>
          </div>
        </div>

        <div
          className='sty-abs sty-screen'
          style={anim({ at: [0.52, 0.6], y: 20 })}
        >
          <div className='sty-h4'>Hi Lena!</div>
          <div className='sty-muted sty-small sty-mt-1'>
            Entdecke deine Stärken mit drei kurzen Spielen.
          </div>
          <div className='sty-mt-4'>
            {GAMES.map((g, i) => (
              <div
                key={g.title}
                className='sty-game-row'
                style={anim({ at: stagger(0.56, 0.03, 0.06, i), x: 20, y: 0 })}
              >
                <Shape kind={g.kind} color={g.color} size={18} />
                <span className='sty-grow'>{g.title}</span>
                <span className='sty-muted sty-small'>{g.dim}</span>
              </div>
            ))}
          </div>
          <div
            className='sty-btn sty-btn--full'
            style={anim({ at: [0.66, 0.74], s: 0.9, y: 10 })}
          >
            Los geht&apos;s
          </div>
        </div>
      </Phone>
    </>
  )
}
